import React from "react";
import { useTranslation } from "react-i18next";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import HomeIcon from "@mui/icons-material/Home";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import GroupsIcon from "@mui/icons-material/Groups";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import { LiveTrainingClubLogo } from "./LiveTrainingClubLogo";

export function LiveTrainingSessionCompletePanel({
  user,
  onGoHome,
  onAddExercise = null,
  onManagePresence = null,
  onReviewCapture = null,
  /** Demo player: request access to the next demo via /demo */
  demoNext = false,
}) {
  const { t } = useTranslation();
  const title = demoNext
    ? t("liveTrainingDemoCompleteTitle", "Demo complete")
    : t("liveTrainingSessionCompleteTitle");
  const message = demoNext
    ? t(
        "liveTrainingDemoCompleteMessage",
        "Request access to the next demo when the coach is ready."
      )
    : t("liveTrainingSessionCompleteMessage");
  const primaryLabel = demoNext
    ? t("liveTrainingDemoCompleteBtn", "Request next demo")
    : t("liveTrainingSessionCompleteBtn");
  const PrimaryIcon = demoNext ? RocketLaunchIcon : HomeIcon;

  return (
    <div className="lt-session-complete" role="status" aria-live="polite">
      <div className="lt-session-complete__glow" aria-hidden />
      <LiveTrainingClubLogo
        user={user}
        size="lg"
        className="lt-session-complete__club-logo"
        showName
      />
      <CheckCircleOutlineIcon className="lt-session-complete__icon" aria-hidden />
      <h2 className="lt-session-complete__title">{title}</h2>
      <p className="lt-session-complete__message">{message}</p>
      <div className="lt-session-decision__actions">
        {onReviewCapture ? (
          <button
            type="button"
            className="lt-session-decision__btn lt-session-decision__btn--secondary"
            onClick={onReviewCapture}
          >
            <EventNoteOutlinedIcon fontSize="small" aria-hidden />
            {t("liveTrainingCaptureSummaryTitle", "Fill the session")}
          </button>
        ) : null}
        {onManagePresence ? (
          <button
            type="button"
            className="lt-session-decision__btn lt-session-decision__btn--secondary"
            onClick={onManagePresence}
          >
            <GroupsIcon fontSize="small" aria-hidden />
            {t("correctSessionPresence") ||
              t("managePlayerPresence") ||
              "Correct presence"}
          </button>
        ) : null}
        {onAddExercise ? (
          <button
            type="button"
            className="lt-session-decision__btn lt-session-decision__btn--secondary"
            onClick={onAddExercise}
          >
            <AddCircleOutlineIcon fontSize="small" aria-hidden />
            {t("liveTrainingAddExercise")}
          </button>
        ) : null}
        <button
          type="button"
          className="lt-session-complete__btn"
          onClick={onGoHome}
        >
          <PrimaryIcon fontSize="small" aria-hidden />
          {primaryLabel}
        </button>
      </div>
    </div>
  );
}

export default LiveTrainingSessionCompletePanel;
